import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarOff, CalendarRange } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { AttendanceWidget } from "@/components/AttendanceWidget";
import { PageHeader } from "@/pages/admin/AdminLayout";

export default function ManagerDashboard() {
  const { user } = useAuth();
  const [pending, setPending] = useState(null);
  useEffect(() => {
    api.get("/absences").then((r) => setPending(r.data.filter((a) => a.status === "in_attesa").length));
  }, []);
  return (
    <div>
      <PageHeader eyebrow={`Responsabile · ${user?.name || ""}`} title="Presenze e assenze">
        <div className="flex gap-2">
          <Button asChild variant="outline" className="rounded-full" data-testid="manager-absences-button">
            <Link to="/admin/assenze"><CalendarOff className="h-4 w-4" /> Assenze da valutare ({pending ?? "–"})</Link>
          </Button>
          <Button asChild className="rounded-full" data-testid="manager-calendar-button">
            <Link to="/admin/presenze"><CalendarRange className="h-4 w-4" /> Calendario</Link>
          </Button>
        </div>
      </PageHeader>
      <AttendanceWidget />
    </div>
  );
}
